<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 13.5H8.5C6.567 13.5 5 11.933 5 10V8.5C5 6.567 6.567 5 8.5 5H10V6.5H8.5C7.395 6.5 6.5 7.395 6.5 8.5V10C6.5 11.105 7.395 12 8.5 12H10.5V13.5ZM13.5 10.5H15.5C17.433 10.5 19 12.067 19 14V15.5C19 17.433 17.433 19 15.5 19H14V17.5H15.5C16.605 17.5 17.5 16.605 17.5 15.5V14C17.5 12.895 16.605 12 15.5 12H13.5V10.5ZM8.939 15.561L15.561 8.939L14.5 7.878L7.878 14.5L8.939 15.561Z" fill="#525C68"/>
    </svg>
</template>

<script>
export default {
    name: 'CustomSectionIcon',
};
</script>
